import React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import styled from "styled-components";
import FAQ from "../components/FrequentlyAskedQ";
import Breadscrum from "../components/Breadscrum";
import LinkButton from "../components/pohrby/LinkButton";
import CallButton from "../components/pohrby/CallButton";
import OverenaFirma from "../components/pohrby/OverenaFirma";
import Img from "gatsby-image";
import { useMediaQuery } from 'react-responsive';
import SwiperCore, { Navigation} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Balon from "../assets/img/balon.svg";
import Coin from "../assets/img/coin.svg";
import Heart from "../assets/img/heart.svg";
import Jo from "../assets/img/pricingCheck.svg";
import SupportPanel from "../components/SupportPanel";
import RecenzePohreb from "../components/pohrby/RecenzePohreb";
import Next from "../assets/img/next.svg";
import Prev from "../assets/img/prev.svg";
import Klauni from "../assets/img/funeralClowns.png";
import PoSvem from "../components/pohrby/PoSvem";
import Jumbotron from "../components/pohrby/Jumbotron";
import Features from "../components/pohrby/Features";
import NaseSluzby from "../components/pohrby/NaseSluzby";
import Postup from "../components/pohrby/Postup";
import KdeFungujeme from "../components/pohrby/KdeFungujeme";
import Press from "../components/pohrby/Press";
import SeVsimPomuzeme from "../components/pohrby/SeVsimPomuzeme";
import StructuredHodnoceni from "../components/pohrby/StucturedHodnoceni";
import Block from "../components/Block";
import ObradniSine from "../components/pohrby/ObradniSine";
import DalsiOdkazy from "../components/pohrby/DalsiOdkazy";
import JumbotronV2 from "../components/brandingV2/JumbotronV2";
import BlogPreview from "../components/brandingV2/BlogPreview";
import RecenzeV2 from "../components/brandingV2/RecenzeV2";
import Intro from "../components/brandingV2/Intro";
import Proces from "../components/brandingV2/Proces";
import NaseSluzbyV2 from "../components/brandingV2/NaseSluzbyV2";
import Mesto from "../components/brandingV2/Mesto";
import FeaturesV2 from "../components/brandingV2/FeaturesV2";
import ObradniSineV2 from "../components/brandingV2/ObradniSineV2";
import NaceneniV2 from "../components/brandingV2/NaceneniV2";
import Ilustrace1 from "../assets/img/ilustracePohreb1.svg";
import Ilustrace2 from "../assets/img/ilustracePohreb2.svg";
import Ilustrace3 from "../assets/img/ilustracePohreb3.svg";
import Ilustrace4 from "../assets/img/ilustracepohreb4.svg";
import EmocniPodpora from "../assets/img/emocniPodpora.svg";
import RegionsV2 from "../components/brandingV2/RegionsV2";
import SingleReview from "../components/brandingV2/SingleReview";

SwiperCore.use([Navigation]);



const RegionyTemplateInner = styled.div`
  ${props => props.longName &&  `
    h1 {
      font-size: 35px !important;

      @media (max-width: 1200px) {
        font-size: 30px !important;
      }

      @media (max-width: 534px) {
        width: 280px;
      }
    }
  
    .rating {
      p {
        font-size: 18px !important;
      }
    }
  `}

  ${props => props.zadnyObrad &&  `
    .naseSluzbyInner {
      .sluzbaBox {
        width: calc((100% - 70px)/2) !important;

        @media (max-width: 1050px) {
          width: 100% !important;
        }
      }
    }
  `}

  .faqs {
    padding-top: 0 !important;
    margin-top: 70px;

    @media (max-width: 600px) {
      margin-top: 50px;
    }
  }

  .jumboImage {
    @media (max-width: 1180px) {
      width: 300px !important;
      height: 304px !important;
    }

    @media (max-width: 899px) {
      width: 320px !important;
      height: 204px !important;
      margin-bottom: 10px;
      margin-top: -10px;
    }

    @media (max-width: 430px) {
      width: 250px !important;
      height: 170px !important;
      margin-bottom: 0px;
      margin-top: -20px;
    }
  }

  .blogPreview {
    background: #F4F3F0;
    padding: 60px 0;
    margin: 70px auto;
    margin-bottom: 0;

    @media (max-width: 600px) {
      margin: 50px auto;
      padding: 40px 0;
    }

    .wrap {
      margin: 0 auto;
    }
  }
`;






const RegionyTemplateV2 = ({
  zadnyObrad,
  longName,
  baby,
  isMainPage,

  name,
  slug,
  seoTitle,
  seoDesc,
  ratingCount,
  faqData,
  jumboObrazek,
  jumboObrazekMobile,
  

  h1,
  perex,
  reviewDesc,
  sklonovaneMesto,
  
  introH2,
  introText,

  procesDesc,
  procesText1,
  procesText2,
  procesText3,
  procesText4,

  mestoH2,
  mestoText,
  mapLocation,

  seVsimPomuzemeText,

  featuresH2,
  featuresText1,
  featuresText2,
  featuresText3,

  kremaceText,
  kremaceCena,
  kremaceSluzby,

  pohrebText,
  pohrebCena,
  pohrebSluzby,

  netradicniText,
  netradicniCena,
  netradicniSluzby,
  
  obradniSine,
  obradniSineH2,

  dalsiOdkazy,
}) => {
  const isPlus470 = useMediaQuery({
    query: '(min-width: 470px)'
  });

  const isLess1050 = useMediaQuery({
    query: '(max-width: 1050px)'
  });

  let data = useStaticQuery(graphql`
    query {

      kovove: file(relativePath: { eq: "kovove.jpg" }) {
        childImageSharp {
          fixed(width: 155) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
  
      drevene: file(relativePath: { eq: "drevene.jpg" }) {
        childImageSharp {
          fixed(width: 155) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
  
      alternativni: file(relativePath: { eq: "alternativni.jpg" }) {
        childImageSharp {
          fixed(width: 155) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      big: file(relativePath: { eq: "pohrebPozadi.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      small: file(relativePath: { eq: "pohrebPozadiSmall.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      recenzeSample: file(relativePath: { eq: "zakaznice4.png" }) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      postup1: file(relativePath: { eq: "postup1.png" }) {
        childImageSharp {
          fluid(maxWidth: 420) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      postup2: file(relativePath: { eq: "postup2.png" }) {
        childImageSharp {
          fluid(maxWidth: 420) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      postup3: file(relativePath: { eq: "postup3.png" }) {
        childImageSharp {
          fluid(maxWidth: 420) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      recenzeSampleSmall: file(relativePath: { eq: "zakaznice4Small.png" }) {
        childImageSharp {
          fixed(width: 80) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      pohrbyJumbo: file(relativePath: { eq: "pohrbyJumbo.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      naseSluzby: file(relativePath: { eq: "naseSluzbyPozadi.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      cremationTip: file(relativePath: { eq: "cremationTip.png" }) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      cremationTipSmall: file(relativePath: { eq: "cremationTip.png" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);

  let structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": name,
    "brand":"Goodbye.cz",
    "image":"https://goodbye.cz/rakev.jpg",
    "description": seoDesc,
    "aggregateRating": {
      "@type":"AggregateRating",
      "bestRating": "5",
      "ratingCount": ratingCount,
      "ratingValue": 4.9,
      "worstRating": "1"}
  };
  
  return (
    <Layout
      subMenuLong
      forcePohrbyMenu
      subMenuItems={[
        {
          name: "Pohřební služba",
          url: "/pohrebni-sluzba/",
        },
        {
          name: "Kde fungujeme?",
          url: "/pobocky/",
        },
        {
          name: "Parte",
          url: "/parte/",
        },
        {
          name: "Kremace bez obřadu",
          url: "/kremace-bez-obradu/",
        },
        {
          name: "Pohřeb s obřadem",
          url: "/pohreb-s-obradem/",
        },
        {
          name: "Netradiční pohřeb",
          url: "/netradicni-pohreb/",
        },
        {
          name: "Pohřeb miminka",
          url: "/pohreb-miminka/",
        },
      ]}
    >
      <SEO
        title={seoTitle}
        customTitle
        description={seoDesc}
        image={baby ? "/detiOg.png" : "/pohrebnisluzbaOg.png"}
      />
      
      <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(structuredData)}}/>

      
      <RegionyTemplateInner longName={longName} zadnyObrad={zadnyObrad}>

        <JumbotronV2
          baby={baby}
          jumboObrazek={jumboObrazek}
          jumboObrazekMobile={jumboObrazekMobile}
          h1={h1}
          p={perex}
          reviewDesc={reviewDesc}
          mapLocation={mapLocation}
          breadscrum={
            <Breadscrum
              visible={true}
              stranky={[
                {name: "Domů", url: "/"},
                {name: name, url: `/${slug}/`},
              ]}
            />
          }
        />

        <RecenzeV2
          customMesto={mapLocation}
          sklonovaneMesto={sklonovaneMesto}
          baby={baby}
        />

        <Intro 
          introH2={introH2}
          introText={introText}
          link={baby ? "https://docs.google.com/forms/d/e/1FAIpQLScKgc40Rm7Y0sTrQ0zQjsYM4BI3wShwUAP_5ma7_KvEfh03WQ/viewform?usp=sf_link" : "/nabidka/dotaznik/"}
        />

        <Proces
          baby={baby}
          procesDesc={procesDesc}
          procesText1={procesText1}
          procesText2={procesText2}
          procesText3={procesText3}
          procesText4={procesText4}
        />

        {baby ?
          <NaceneniV2
            baby={baby}
            h2={<>Žádné skryté poplatky,<br/>vše potřebné je již v ceně</>}
            p="To, jak se rozloučíte, je jen na vás. My se postaráme o vše ostatní za jednu transparentní cenu."
            checklist={["Sjednání do pár minut přes internet", "Přeprava vašeho miminka k nám", "Vyřízení veškerých dokumentů", "Pomoc s výběrem památečních předmětů a parte", "Samotná kremace včetně poplatků", "Předání urny dle vašeho výběru"]}
            price="14 990 Kč"
            feature="S námi ušetříte 8 000 Kč oproti průměrné ceně pohřu v ČR"
            extrasText="Nabízíme i možnost připlatit si za jiné urny"
            extras={[
              {
                h4: "Kovové a keramické",
                p: "Dostupné ve více barevných kombinacích.",
                price: "1 990 - 2 990 Kč",
                img: data.kovove.childImageSharp.fixed,
              },
              {
                h4: "Dřevěné",
                p: "Tradiční i netradiční variatny v několika velikostech.",
                price: "3 190 - 3 390 Kč",
                img: data.drevene.childImageSharp.fixed,
              },
              {
                h4: "Ekologické",
                p: "Urny, které se po uložení do země sami rozloží.",
                price: "790 - 1 990 Kč",
                img: data.alternativni.childImageSharp.fixed,
              },
            ]}
          />
        :
          <NaseSluzbyV2
            zadnyObrad={zadnyObrad}

            kremaceText={kremaceText}
            kremaceCena={kremaceCena}
            kremaceSluzby={kremaceSluzby}

            pohrebText={pohrebText}
            pohrebCena={pohrebCena}
            pohrebSluzby={pohrebSluzby}

            netradicniText={netradicniText}
            netradicniCena={netradicniCena}
            netradicniSluzby={netradicniSluzby}
          />
        }

        
        {!isMainPage &&
          <Mesto
            mapLocation={mapLocation}
            mestoH2={mestoH2}
            mestoText={mestoText}
            baby={baby}
          />
        }

        {isMainPage && <RegionsV2 isMainPage />}

        <FeaturesV2
          baby={baby}
          customH2={featuresH2 ? featuresH2 : "Profesionalita a důstojnost je na prvním místě"}
          heading1="Vše vyřešíme přes internet"
          heading2="Vždy za transparentní ceny"
          heading3={baby ? "Budeme vám oporou" : "Poskytneme vám speciální péči"}
          text1={featuresText1 ? featuresText1 : "S námi celý pohřeb naplánujete z bezpečí domova. Nemusíte nikam chodit. Vše si můžete v klidu rozmyslet a poradit se s rodinou."}
          text2={featuresText2 ? featuresText2 : "Cena, na které se s naší pohřební službou domluvíte, je vždy konečná. Obsahuje kompletně vše, co budete potřebovat."}
          text3={featuresText3 ? featuresText3 : "O vše se postaráme za vás: vyřízení dokumentů na matrice, osobní doručení urny nebo převod digitálních účtů vašeho blízkého."}
          ilustrace1={Ilustrace3}
          ilustrace2={Ilustrace2}
          ilustrace3={baby ? EmocniPodpora : Ilustrace4}
        />
        

        {obradniSine && 
          <ObradniSineV2
            sine={obradniSine}
            h2={obradniSineH2}
          />
        }

        

        {!isMainPage && <Press />}

        {isMainPage && <SingleReview />}



        {isMainPage &&
          <Mesto
            white
            mestoH2={mestoH2}
            mestoText={mestoText}
          />
        }



        <SeVsimPomuzeme
          customText={seVsimPomuzemeText}
        />

        {!isMainPage && <RegionsV2 />}





        <FAQ className={"faqs"} data={faqData}/>

        {dalsiOdkazy && <DalsiOdkazy data={dalsiOdkazy}/> }

        {isMainPage && <BlogPreview />}


      </RegionyTemplateInner>
    </Layout>
  );
}


export default RegionyTemplateV2;


